<template>
  <div>
    <loader :loader="loader || sending" />
    <autoLogout />
    <div class="wrapper-content">
      <encabezado
        :elementos="encabezado"
        :disabledButton="disabledHeader"
        v-if="showAction(1)"
      />
      <v-card v-if="showAction(1)">
        <!-- <v-card v-if="showAction(1)"> -->
        <v-card-text>
          <div name="table">
            <v-row class="mt-2 mb-1">
              <v-col cols="12" md="3" xl="3" sm="12">
                <branch-offices-list
                  v-on:triggerChange="branchOfficeSelected"
                  :dense="true"
                  :model="idBranchOfficeSelected"
                />
              </v-col>

              <v-col cols="12" md="3" xl="3" sm="12">
                <vc-date-picker
                  color="green"
                  v-model="range"
                  is-range
                  :max-date="new Date()"
                  class="pb-0"
                >
                  <template v-slot="{ inputEvents }">
                    <div class="d-flex justify-center align-center">
                      <v-text-field
                        v-on="inputEvents.start"
                        :value="rangeComputed"
                        label="Seleccione fecha"
                        :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'"
                        @click:append="clearCalendar"
                        dense
                        :disabled-input="validData"
                      ></v-text-field>
                    </div>
                  </template>
                </vc-date-picker>
              </v-col>

              <v-col cols="12" md="4" xl="4" sm="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                  dense
                >
                </v-text-field>
              </v-col>

              <v-col
                cols="12"
                md="2"
                xl="2"
                sm="12"
                v-if="$utilFront.withPermission($prm.ADD_PATIENT)"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      @click="$router.push('/recepcion/registrarPaciente')"
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      block
                      dense
                    >
                      <v-icon left>mdi-plus-circle</v-icon>
                      Nuevo
                    </v-btn>
                  </template>
                  <span>Registrar paciente</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <template>
              <v-data-table
                :headers="headers"
                :items="listaPacientes"
                hide-default-footer
                :footer-props="{
                  'items-per-page-text': 'Elementos por página',
                  'items-per-page-all-text': 'Todo',
                }"
                no-results-text="Sin resultados coincidentes con la búsqueda"
                loading-text="Cargando..."
                no-data-text="Sin resultados disponibles"
                dense
                calculate-widths
                fixed-header
                height="auto"
              >
                <template v-slot:[`item.counter`]="{ index }">
                  {{ currentPage * itemsPerPage - itemsPerPage + index + 1 }}
                </template>
                <template v-slot:[`item.registrationDate`]="{ item }">
                  {{ $utilFront.formatDateTime(item.registrationDate) }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip top v-if="displayQrStudy">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small @click="downloadMiEstudioPDF(item)">
                        <v-icon v-bind="attrs" v-on="on" color="error">
                          mdi-file-pdf-box
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar mi estudio</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="$utilFront.withPermission($prm.MAKE_AN_APPOINTMENT)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="secondary"
                        icon
                        small
                        @click="createAppointment(item)"
                      >
                        <v-icon v-bind="attrs" v-on="on"> mdi-calendar </v-icon>
                      </v-btn>
                    </template>
                    <span>Agendar cita</span>
                  </v-tooltip>
                  <v-menu
                    offset-y
                    :nudge-width="100"
                    :close-on-content-click="true"
                  >
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            icon
                            small
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                          >
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <span>Más opciones</span>
                      </v-tooltip>
                    </template>

                    <v-list dense>
                      <v-list-item
                        link
                        @click="getPatient(item.idPatient)"
                        v-if="$utilFront.withPermission($prm.UPDATE_PATIENT)"
                      >
                        <v-list-item-icon>
                          <v-icon color="blue"> mdi-pencil </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title> Editar </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item
                        link
                        @click="changeViewAddendums(item)"
                        :disabled="sending"
                      >
                        <v-list-item-icon>
                          <v-icon> mdi-file-image </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title> Ver archivos </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        link
                        router
                        :to="{
                          path: '/recepcion/addendum',
                          name: 'Addendum',
                          params: { id: item.idPatient },
                        }"
                        v-if="$utilFront.withPermission($prm.ADD_ADDENDUM)"
                      >
                        <v-list-item-icon>
                          <v-icon> mdi-paperclip </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Agregar archivos
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
              <v-row dense>
                <v-col cols="8" md="8" sm="8" offset="2" class="text-center">
                  <paginatesx
                    :click-handler="changePage"
                    :page-count="pageCount"
                    :page-range="1"
                    :margin-pages="1"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </paginatesx>
                </v-col>
                <v-col cols="2" md="2" sm="2" class="text-center mt-5">
                  <v-banner outlined single-line>
                    Total: {{ totalCount }}</v-banner
                  >
                </v-col>
              </v-row>
            </template>
            <!-- <template>

            </template> -->
          </div>
        </v-card-text>
        <v-card-actions align="center">
          <v-col
            v-if="
              $utilFront.withPermission($prm.MODULE_RECEPTION_DOWNLOAD_EXCEL)
            "
          >
            <export-import-btn
              texto="Exportar pacientes"
              icono="export"
              color="green darken-1"
              @accion="downloadReport(2)"
            />
          </v-col>
          <v-col v-if="false">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="error"
                  :disabled="sending"
                  @click="downloadReport(1)"
                >
                  Exportar pacientes
                  <v-icon right> mdi-file-pdf-box </v-icon>
                </v-btn>
              </template>
              <span>Descargar archivo PDF</span>
            </v-tooltip>
          </v-col>
        </v-card-actions>
      </v-card>

      <v-card v-if="showAction(2)">
        <v-card-text>
          <div name="interpretation" class="ml-5 mr-5 mb-12">
            <patient-information :model="model" class="mb-4 mt-4" />

            <v-divider class="mt-8 mb-8"></v-divider>
            <v-row dense >
              <v-data-table
              v-if="false"
                :headers="headersAddendums"
                :items="addendums"
                :items-per-page="10"
                no-data-text="Sin resultados disponibles"
                dense
                fixed-header
                hide-default-footer
              >
                <!-- <template v-slot:[`item.registrationDate`]="{ item }">
                  {{ $utilFront.formatDateTime(item.registrationDate) }}
                </template>
                <template v-slot:[`item.hasUser`]="{ item }">
                  <v-icon color="success" v-if="item.hasUser"
                    >mdi-checkbox-blank-circle</v-icon
                  >
                  <v-icon color="error" v-if="!item.hasUser"
                    >mdi-checkbox-blank-circle</v-icon
                  >
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip
                    top
                    v-if="$utilFront.withPermission($prm.UPDATE_DOCTOR)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon @click="get(item, 3)" dense x-small>
                        <v-icon color="secondary" v-bind="attrs" v-on="on">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      item.hasUser &&
                      $utilFront.withPermission($prm.RESET_PASSWORD_DOCTOR)
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        @click="openDialogRestore(item)"
                        dense
                        x-small
                        class="ml-2"
                      >
                        <v-icon color="yellow" v-bind="attrs" v-on="on">
                          mdi-restart
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Restaurar contraseña</span>
                  </v-tooltip>
                  <span
                    v-if="
                      !$utilFront.withPermission($prm.UPDATE_DOCTOR) &&
                      (!$utilFront.withPermission($prm.RESET_PASSWORD_DOCTOR) ||
                        !item.hasUser)
                    "
                  >
                    - - -
                  </span>
                </template> -->
              </v-data-table>
              <v-col
                class="col-md-2"
                style="text-align: center"
                v-for="(file, index) in addendums"
                :key="file.fileName"
                :id="index"
              >
                <!--<img id="imgSign" :src="'data:image/*;base64,'+file.bytes"/>-->
                <!--<pdf :src="'data:pdf/*;base64,'+file.bytes"></pdf>-->
                <v-icon
                  type="button"
                  @click="visualizar(file)"
                  size="40px"
                  :color="
                    file.type === 'application/pdf'
                      ? 'error'
                      : 'grey' || file.type === 'image/jpeg'
                      ? 'secondary'
                      : 'grey'
                  "
                  >{{
                    file.type === "application/pdf"
                      ? "mdi-file-pdf-box"
                      : "mdi-file" || file.type === "image/jpeg"
                      ? "mdi-image"
                      : "mdi-file"
                  }}</v-icon
                >
                <p style=" text-align: center">
                  {{ file.fileName }}
                </p>
              </v-col>
            </v-row>
            <v-row v-if="addendums.length == 0">
              <v-col>
                <strong>
                  <p>No se encontraron archivos</p>
                </strong>
              </v-col>
            </v-row>

            <v-row align="center" justify="space-around" class="mt-10">
              <v-btn
                outlined
                type="button"
                @click="changeAction(1)"
                color="error"
              >
                <v-icon left>mdi-chevron-left</v-icon> Volver
              </v-btn>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
      <encabezado :elementos="titleUpdate" v-if="showAction(3)" />
      <v-card v-if="showAction(3)">
        <v-card-text>
          <v-container>
            <validation-observer v-slot="{ invalid }">
              <v-form id="editPatient">
                <v-row class="mb-5" dense>
                  <v-col cols="12" sm="12" md="12">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text"
                      shaped
                      single-line
                    >
                      Información de identificación médica
                    </v-banner>
                  </v-col>
                </v-row>

                <v-row class="mb-3" dense>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors, valid }"
                      name="CURP"
                      rules="requiredCurp|curp"
                    >
                      <v-text-field
                        v-model="formEditar.person.curp"
                        :value="formEditar.person.curp"
                        :counter="18"
                        :maxlength="18"
                        :error-messages="errors"
                        label="CURP"
                        name="curp"
                        id="curp"
                        required
                        dense
                        @input="upperCase($event)"
                        @blur="validateCurp"
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        :append-icon="
                          valid ? $cnst.VALID_ICON : $cnst.ALERT_ICON
                        "
                        color="primary"
                      />
                    </validation-provider>
                    <p class="caption text--secondary">
                      Si desconoce la CURP utiliza el formato XXXX999999XXXXXX99
                    </p>
                  </v-col>

                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Institución aseguradora"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="formEditar.healthInsurance.idHealthInsurance"
                        :value="formEditar.healthInsurance.idHealthInsurance"
                        :items="listHealthInsurance"
                        :item-value="listHealthInsurance.value"
                        :item-text="listHealthInsurance.text"
                        :error-messages="errors"
                        no-data-text="Sin aseguradoras por mostrar"
                        label="Institución aseguradora"
                        return-object
                        required
                        dense
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>

                  <template v-if="isImss">
                    <v-col cols="12" md="3" sm="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="NSS"
                        rules="max:11|min:11|numeric|required"
                      >
                        <v-text-field
                          clearable
                          outlined
                          :clear-icon="$cnst.CLEAR_ICON"
                          v-model="formEditar.imssNumber"
                          :value="formEditar.imssNumber"
                          :counter="11"
                          :error-messages="errors"
                          label="NSS"
                          name="patientNSS"
                          id="patientNSS"
                          dense
                          required
                        ></v-text-field>
                      </validation-provider>
                      <p class="caption text--secondary">
                        Si desconoce su número de afiliación o NSS utiliza el
                        formato 00000000000
                      </p>
                    </v-col>

                    <v-col cols="12" md="3" sm="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Agregado médico"
                        rules="max:8|min:8|regex:^[a-zA-Z0-9]+$"
                      >
                        <v-text-field
                          clearable
                          outlined
                          :clear-icon="$cnst.CLEAR_ICON"
                          v-model="formEditar.medicalAggregated"
                          :value="formEditar.medicalAggregated"
                          :counter="8"
                          :error-messages="errors"
                          label="Agregado médico"
                          dense
                          name="medicalAggregated"
                          id="medicalAggregated"
                          required
                          @input="
                            if (formEditar.medicalAggregated)
                              formEditar.medicalAggregated =
                                $event.toUpperCase();
                          "
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </template>

                  <template v-if="isOther">
                    <v-col cols="12" md="3" sm="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Nombre de aseguradora"
                        rules="alpha|max:100"
                      >
                        <v-text-field
                          v-model="formEditar.nameOther"
                          prepend-icon="mdi-shield"
                          label="Nombre de aseguradora"
                          :error-messages="errors"
                          :counter="100"
                          dense
                          clearable
                          outlined
                          :clear-icon="$cnst.CLEAR_ICON"
                          :maxlength="100"
                          required
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Descripción"
                        rules="regex:^[a-zA-Z0-9 ]+$|max:100"
                      >
                        <v-text-field
                          v-model="formEditar.description"
                          prepend-icon="mdi-information-variant"
                          :counter="100"
                          dense
                          clearable
                          outlined
                          :clear-icon="$cnst.CLEAR_ICON"
                          :maxlength="100"
                          label="Descripción"
                          :error-messages="errors"
                          required
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </template>

                  <template v-if="isIssste">
                    <v-col cols="12" md="3" sm="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Número de afiliación"
                      >
                        <v-text-field
                          v-model="formEditar.membershipNumber"
                          label="Número de afiliación"
                          :counter="50"
                          dense
                          clearable
                          outlined
                          :clear-icon="$cnst.CLEAR_ICON"
                          :error-messages="errors"
                          required
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </template>
                </v-row>

                <v-row class="mb-5" dense>
                  <v-col cols="12" sm="12" md="12">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text"
                      shaped
                      single-line
                    >
                      Información personal
                    </v-banner>
                  </v-col>
                </v-row>

                <v-row class="mb-3" dense>
                  <v-col cols="12" md="3" sm="12">
                    <!-- rules="required|max:60|min:2|nameWithDot" -->

                    <validation-provider
                      v-slot="{ errors }"
                      name="Nombre(s)"
                      rules="required|max:60|min:2"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.name"
                        :value="formEditar.person.name"
                        :error-messages="errors"
                        label="Nombre(s)"
                        dense
                        :counter="60"
                        id="name"
                        required
                        @input="capitalizeName($event)"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Primer apellido"
                      rules="required|max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.firstLastname"
                        :value="formEditar.person.firstLastname"
                        label="Primer apellido"
                        dense
                        :error-messages="errors"
                        :counter="60"
                        id="firstLastname"
                        required
                        @input="capitalizeLastname($event)"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Segundo apellido"
                      rules="max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.secondLastname"
                        :value="formEditar.person.secondLastname"
                        :error-messages="errors"
                        label="Segundo apellido"
                        dense
                        id="secondLastName"
                        :counter="60"
                        required
                        @input="capitalizeSurname($event)"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Sexo"
                      rules="required"
                    >
                      <v-select
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.gender"
                        :value="formEditar.person.gender"
                        :items="genero"
                        :item-text="genero.text"
                        dense
                        :item-value="genero.value"
                        :error-messages="errors"
                        label="Sexo"
                        required
                      >
                      </v-select>
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row class="mb-3" dense>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Nacionalidad"
                    >
                      <v-autocomplete
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.nationality"
                        label="Nacionalidad"
                        :rules="nameRules"
                        dense
                        :items="nationality"
                        :item-text="nationality.text"
                        :item-value="nationality.value"
                        :error-messages="errors"
                        required
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <template
                    v-if="
                      formEditar.person.nationality &&
                      formEditar.person.nationality === 'Otro'
                    "
                  >
                    <v-col cols="3" md="3" sm="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Nombre de Nacionalidad"
                        rules="required|alpha"
                      >
                        <v-text-field
                          clearable
                          outlined
                          :clear-icon="$cnst.CLEAR_ICON"
                          v-model="otherNationality"
                          label="Nombre de Nacionalidad*"
                          dense
                          :error-messages="errors"
                          :counter="50"
                          required
                        >
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                  </template>

                  <v-col>
                    <!-- <vc-date-picker
                            :max-date="new Date()"
                            color="green"
                            v-model="date"
                          > -->
                    <!-- <template v-slot="{ inputEvents, inputValue }"> -->
                    <v-text-field
                      type="date"
                      v-model="date2"
                      label="Fecha de nacimiento*"
                      :rules="nameRules"
                      hint="Formato DD/MM/YYYY"
                      required
                      dense
                      clearable
                      outlined
                      :clear-icon="$cnst.CLEAR_ICON"
                      :max="new Date().toISOString().split('T')[0]"
                    ></v-text-field>
                    <!-- </template> -->
                    <!-- </vc-date-picker> -->
                  </v-col>
                  <!-- <v-col>
                    <vc-date-picker
                      :max-date="new Date()"
                      color="green"
                      v-model="date2"
                    >
                      <template v-slot="{ inputEvents, inputValue }">
                        <v-text-field
                          v-on="inputEvents"
                          :value="inputValue"
                          label="Fecha de nacimiento*"
                          :rules="nameRules"
                          hint="Formato DD/MM/YYYY"
                          required
                        ></v-text-field>
                      </template>
                    </vc-date-picker>
                  </v-col> -->
                  <v-col
                    v-if="formEditar.person.nationality != 'Otro'"
                    cols="12"
                    md="3"
                    sm="12"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="Entidad federativa de nacimiento"
                      rules="required"
                    >
                      <v-autocomplete
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        label="Entidad federativa de nacimiento"
                        v-model="formEditar.person.birthFederalEntity"
                        :error-messages="errors"
                        dense
                        :items="birthFederalEntities"
                        :item-text="birthFederalEntities.text"
                        :item-value="birthFederalEntities.value"
                        required
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Estado civil"
                      rules="required"
                    >
                      <v-autocomplete
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.maritalStatus"
                        label="Estado civil"
                        :items="estadoCivil"
                        dense
                        required
                        :item-text="estadoCivil.text"
                        :item-value="estadoCivil.value"
                        :error-messages="errors"
                      >
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <!-- <v-col cols="12" md="3" sm="12">
  <validation-provider
    v-slot="{ errors }"
    name="Lengua indígena"
    rules="required"
  >
    <v-select
      prepend-icon="mdi-tilde"
      v-model="formEditar.person.indigenousLanguage"
      :items="languages"
      :item-text="item => item.text"
      :item-value="item => item.value"
      label="Lengua indígena"
      :error-messages="errors"
      required
    />
  </validation-provider>
</v-col> -->
                  <v-col cols="12" md="3" sm="12">
  <validation-provider
    v-slot="{ errors }"
    name="Lengua indígena"
    rules="required"
  >
    <v-select
      prepend-icon="mdi-tilde"
      v-model="formEditar.person.indigenousLanguage"
      :items="languages"
      :item-text="item => item.text"
      :item-value="item => item.value"
      label="Lengua indígena"
      :error-messages="errors"
      required
    />
  </validation-provider>
</v-col>
                  <v-col cols="12" md="3" sm="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="RFC"
                        rules="max:13|min:12"
                      >
                        <v-text-field
                          clearable
                          outlined
                          dense
                          :clear-icon="$cnst.CLEAR_ICON"
                          v-model="formEditar.rfc"
                          :error-messages="errors"
                          label="RFC"
                          :counter="13"
                          :maxlength="13"
                          @input="if(formEditar.rfc)formEditar.rfc = $event.toUpperCase()"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                </v-row>

                <v-row>
                  <v-col cols="5" md="5" sm="12" v-if="showVotingLicense">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text mb-5"
                      shaped
                      single-line
                    >
                      Información electoral
                    </v-banner>
                    <v-row class="mb-5" dense>
                      <v-col cols="7" md="7" sm="12" v-if="showVotingLicense">
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model.trim="votingLicenseKey"
                        label="Clave de elector"
                        :counter="18"
                        dense
                        :maxlength="18"
                      >
                      </v-text-field>
                      </v-col>
                      <v-col cols="5" md="5" sm="12" v-if="showVotingLicense">
                        <v-text-field
                          clearable
                          outlined
                          :clear-icon="$cnst.CLEAR_ICON"
                          v-model.trim="section"
                          label="Sección"
                          :counter="5"
                          dense
                          :maxlength="5"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4" md="4" sm="12">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text mb-5"
                      shaped
                      single-line
                    >
                      Información laboral
                    </v-banner>
                    <v-row class="mb-5" dense>
                      <v-col cols="12">
                      <v-autocomplete
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.occupation"
                        label="Ocupación"
                        :items="joblist"
                        item-text="name"
                        return-object
                        dense
                        no-data-text="sin ocupaciones para mostrar"
                      >
                      </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3" md="3" sm="12">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text mb-5"
                      shaped
                      single-line
                    >
                      Información escolar
                    </v-banner>
                    <v-row class="mb-5" dense>
                      <v-col cols="12">
                        <v-autocomplete
                          clearable
                          outlined
                          :clear-icon="$cnst.CLEAR_ICON"
                          v-model="formEditar.educationName"
                          label="Escolaridad"
                          :items="$cnst.SCHOOL_GRADES"
                          item-text="name"
                          return-object
                          dense
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <!-- <v-row class="mb-5" dense>
                  <v-col v-if="showVotingLicense">
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text"
                      shaped
                      single-line
                    >
                      Información electoral
                    </v-banner>
                  </v-col>
                  <v-col>
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text"
                      shaped
                      single-line
                    >
                      Información laboral
                    </v-banner>
                  </v-col>
                </v-row>

                <v-row class="mb-5" dense>
                  <v-col cols="3" md="3" sm="12" v-if="showVotingLicense">
                    <v-text-field
                      clearable
                      outlined
                      :clear-icon="$cnst.CLEAR_ICON"
                      v-model.trim="votingLicenseKey"
                      label="Clave de elector"
                      :counter="18"
                      dense
                      :maxlength="18"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="3" md="3" sm="12" v-if="showVotingLicense">
                    <v-text-field
                      clearable
                      outlined
                      :clear-icon="$cnst.CLEAR_ICON"
                      v-model.trim="section"
                      label="Sección"
                      :counter="5"
                      dense
                      :maxlength="5"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" md="6" sm="12">
                    <v-autocomplete
                      clearable
                      outlined
                      :clear-icon="$cnst.CLEAR_ICON"
                      v-model="formEditar.occupation"
                      label="Ocupación"
                      :items="joblist"
                      item-text="name"
                      return-object
                      dense
                      no-data-text="sin ocupaciones para mostrar"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row> -->

                <v-row class="mb-5" dense>
                  <v-col>
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text"
                      shaped
                      single-line
                    >
                      Información de contacto
                    </v-banner>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" md="6" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Dirección"
                      rules="required|max:100|regex:^[a-zA-Z0-9 ]"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.street"
                        label="Dirección"
                        :counter="100"
                        dense
                        :error-messages="errors"
                        id="directionStreet"
                        required
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Número exterior"
                      rules="max:5|required"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.outdoorNumber"
                        :counter="5"
                        dense
                        :maxLength="5"
                        :error-messages="errors"
                        label="Número exterior"
                        required
                      >
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Número interior"
                      rules="max:5|required"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.interiorNumber"
                        label="Número interior"
                        :error-messages="errors"
                        :counter="5"
                        dense
                        :maxLength="5"
                      ></v-text-field>
                    </validation-provider>
                    <p class="caption text--secondary">
                      Si el domicilio no cuenta con número interior utiliza el
                      formato N/D
                    </p>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Código postal"
                      rules="required|max:5|min:1|numeric|regex:^[0-9]+$"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.postalCode"
                        :value="formEditar.person.address.postalCode"
                        @change="findAddress"
                        label="Código postal"
                        :counter="5"
                        dense
                        maxlength="5"
                        :error-messages="errors"
                        id="directionPostalCode"
                        required
                      >
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" v-if="!noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Entidad federativa"
                      rules="required"
                    >
                      <v-autocomplete
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.federalEntityKey"
                        :items="federalEntities"
                        :item-text="federalEntities.text"
                        :item-value="federalEntities.value"
                        :error-messages="errors"
                        label="Entidad federativa"
                        id="directionState"
                        dense
                        required
                        :disabled="validAdress"
                      >
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" v-if="!noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Municipio"
                      rules="required"
                    >
                      <v-autocomplete
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.municipalityKey"
                        :value="formEditar.person.address.municipalityKey"
                        :items="municipalities"
                        :item-text="municipalities.text"
                        :item-value="municipalities.value"
                        :error-messages="errors"
                        label="Municipio"
                        dense
                        id="directionCity"
                        required
                        :disabled="validAdress"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" v-if="!noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Colonia"
                      rules="required"
                    >
                      <v-autocomplete
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.colonyKey"
                        :value="formEditar.person.address.colonyKey"
                        :items="colonies"
                        :error-messages="errors"
                        label="Colonia"
                        id="directionColony"
                        dense
                        required
                        :disabled="validAdress"
                        @change="checkColony"
                      >
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" v-if="noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Entidad federativa"
                      rules="required|max:100"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.federalEntityKey"
                        label="Entidad federativa de residencia*"
                        :counter="100"
                        dense
                        :maxlength="100"
                        :error-messages="errors"
                        required
                      ></v-text-field>
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" md="3" sm="12" v-if="noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Municipio"
                      rules="required|max:100"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.address.municipalityKey"
                        :counter="100"
                        dense
                        :maxlength="100"
                        label="Municipio*"
                        :error-messages="errors"
                        required
                      ></v-text-field>
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" md="3" sm="12" v-if="noPostal || noColony">
                    <validation-Provider
                      v-slot="{ errors }"
                      name="Colonia"
                      rules="required|max:100"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="otherColony"
                        label="Colonia*"
                        :error-messages="errors"
                        required
                        :counter="100"
                        dense
                        :maxlength="100"
                      ></v-text-field>
                    </validation-Provider>
                  </v-col>
                </v-row>

                <v-row class="mb-3">
                  <v-col cols="12" md="4" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Correo electrónico"
                      rules="email|required"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.contactInformation.email"
                        :value="formEditar.person.contactInformation.email"
                        :error-messages="errors"
                        label="Correo electrónico"
                        id="correo"
                        :counter="50"
                        dense
                        :maxlength="50"
                        type="email"
                        @input="
                          if (objAltaPaciente.email)
                            objAltaPaciente.email = $event.toLowerCase();
                        "
                      ></v-text-field>
                    </validation-provider>
                    <p class="caption text--secondary">
                      Si desconoce el correo electrónico utiliza el formato N/D
                    </p>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Número telefónico movil"
                      rules="max:10|min:10|phonenumber|required"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.contactInformation.phone"
                        :value="formEditar.person.contactInformation.phone"
                        :error-messages="errors"
                        label="Número telefónico móvil"
                        id="mobilePhone"
                        :counter="10"
                        dense
                        :maxlength="10"
                        required
                      >
                      </v-text-field>
                    </validation-provider>
                    <!-- <p class="caption text--secondary">
                      Si desconoce el número telefónico utiliza el formato
                      0000000000
                    </p> -->
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Número telefónico fijo"
                      rules="max:10|min:10|phonenumber"
                    >
                      <v-text-field
                        clearable
                        outlined
                        :clear-icon="$cnst.CLEAR_ICON"
                        v-model="formEditar.person.contactInformation.homePhone"
                        :value="formEditar.person.contactInformation.homePhone"
                        :error-messages="errors"
                        label="Número telefónico fijo (Opcional)"
                        id="mobilePhone"
                        :counter="10"
                        dense
                        :maxlength="10"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="pt-0" cols="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Enviar informacion"
                        rules="required"
                      >
                        <v-radio-group 
                          class="pt-0"
                          row 
                          v-model="formEditar.sendInformation"
                          :error-messages="errors"
                        >
                          <template v-slot:label>
                            <div><h4  style="font-size:auto">¿Deseas que te enviemos información?</h4></div>
                          </template>
                          <v-radio :value="true">
                            <template v-slot:label>
                              <div><strong>Sí</strong></div>
                            </template>
                          </v-radio>
                          <v-radio :value="false">
                            <template v-slot:label>
                              <div><strong>No</strong></div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </validation-provider>
                  </v-col>
                </v-row>

                <v-row class="mb-5" dense>
                  <v-col>
                    <v-banner
                      color="blue-grey lighten-5"
                      class="br black--text"
                      shaped
                      single-line
                    >
                      Antecedentes
                    </v-banner>
                  </v-col>
                </v-row>

                <v-row dense class="mb-3">
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel
                      v-for="(item, index) in antecedents"
                      :key="index"
                    >
                      <v-expansion-panel-header>
                        {{ index + 1 + ".- " + item.name }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row align="baseline" justify="center" dense>
                          <v-col
                            v-for="(question, subindex) in item.questions"
                            :key="subindex"
                          >
                            <span>{{ question.name }}</span>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="question.name"
                              :rules="question.required == 1 ? 'required' : ''"
                            >
                              <v-radio-group
                                v-if="
                                  question.typeAnswer == 2 ||
                                  question.typeAnswer == 4
                                "
                                v-model="question.idAnswer"
                                :error-messages="errors"
                                :required="question.required == 1"
                                dense
                              >
                                <v-radio
                                  v-for="(
                                    answer, sub_subindex
                                  ) in question.answers"
                                  :key="sub_subindex"
                                  :value="answer.idAnswer"
                                  :label="answer.name"
                                />
                              </v-radio-group>

                              <v-autocomplete
                                v-if="question.typeAnswer == 3"
                                v-model="question.selectedAnswers"
                                :items="question.answers"
                                item-text="name"
                                item-value="idAnswer"
                                :error-messages="errors"
                                auto-select-first
                                chips
                                clearable
                                deletable-chips
                                multiple
                                small-chips
                                dense
                                outlined
                                :clear-icon="$cnst.CLEAR_ICON"
                                :required="question.required == 1"
                              />

                              <v-text-field
                                v-if="
                                  (question.typeAnswer == 1 ||
                                    question.typeAnswer == 4) &&
                                  question.typeData != 6
                                "
                                v-model="question.answer"
                                :error-messages="errors"
                                :type="question.typeDataText"
                                :required="question.required == 1"
                                autocomplete="off"
                                dense
                                clearable
                              />

                              <v-textarea
                                v-if="
                                  (question.typeAnswer == 1 ||
                                    question.typeAnswer == 4) &&
                                  question.typeData == 6
                                "
                                v-model="question.answer"
                                :error-messages="errors"
                                outlined
                                dense
                                clearable
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>

                <v-row>
                  <v-col>
                    <h3 class="font-weight-black mb-5">Fotografía</h3>
                  </v-col>
                </v-row>

                <v-row align="center" justify="center">
                  <v-col class="text-center" cols="12" md="4" sm="12">
                    <v-img
                      class="mx-auto mb-7"
                      max-width="350"
                      :src="formEditar.person.photoPerson"
                    ></v-img>
                    <h3>
                      {{
                        formEditar.person.photoPerson
                          ? "Fotografía actual"
                          : "El paciente no cuenta con fotografía"
                      }}
                    </h3>
                  </v-col>

                  <v-col cols="12" md="4" sm="12">
                    <CameraSuim :videoTypes="['camera']" ref="cameraSUIM" />
                  </v-col>
                </v-row>

                <v-row justify="center" align="center" class="text-center">
                  <v-col>
                    <v-btn
                      text
                      type="button"
                      @click="changeAction(1)"
                      color="error"
                    >
                      <v-icon left>mdi-chevron-left</v-icon> Volver
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      color="primary"
                      @click="editPatient"
                      :disabled="invalid || sending"
                    >
                      Guardar cambios
                      <v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </validation-observer>
          </v-container>
        </v-card-text>
      </v-card>
    </div>

    <!--start Modals -->
    <v-dialog v-model="dialogDelete" persistent max-width="450">
      <v-card>
        <v-card-title class="text-h6 text-center"> Advertencia </v-card-title>
        <v-card-text
          >¿Desea {{ objDelete.status === false ? "activar" : "desactivar" }} el
          registro del paciente:
          <span class="font-weight-black"
            >{{ objDelete.fullNamePatient }} ({{ objDelete.idPatient }})</span
          >?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="sending"
            text
            @click="deletePatient"
          >
            Aceptar
          </v-btn>
          <v-col>
            <export-import-btn
              texto="Exportar pacientes"
              icono="export"
              color="green darken-1"
              @accion="exportBranchOffice()"
            />
          </v-col>
        </v-card-actions>
        <v-row align="baseline" justify="center" class="pb-4">
          <v-col class="text-center">
            <export-import-btn
              texto="Exportar pacientes"
              icono="export"
              color="green darken-1"
              @accion="exportBranchOffice()"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogViewer"
      persistent
      max-width="800px"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title class="text-h6 text-center"> Archivo anexo </v-card-title>
        <v-card-text>
          Nombre: {{ file.name }}
          <br />
          Fecha de registro: {{ file.registrationDate }}
        </v-card-text>

        <div class="container" v-if="file.type != 'application/pdf'">
          <div style="justify-content: center" class="row overflow-y-auto">
            <img
              id="imgSign"
              download
              width="auto"
              height="400"
              :src="'data:image/*;base64,' + file.file"
            />
          </div>
        </div>
        <div class="container" v-if="file.type == 'application/pdf'">
          <Viewer :file="file" />
        </div>
        <v-card-actions style="justify-content: center">
          <v-btn color="secondary" text @click="dialogViewer = false">
            <v-icon left>mdi-chevron-left</v-icon>Regresar
          </v-btn>
          <v-btn
            color="error"
            text
            @click="deleteFile(file)"
            :disabled="disabledButton"
          >
            Eliminar<v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="download(file)"
            :disabled="disabledButton"
          >
            <!-- <a :href="'data:image/*;base64,'+url" download class="btn btn-success">Descargar imagen</a>-->
            Descargar<v-icon right>mdi-download</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Información de usuario con CURP repetido -->
    <v-dialog v-model="modelInfoPatient" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h6 text-center error--text">
          Se encontró {{ patientInfoList.length }} usuario(s) con la misma CURP
          ingresada
        </v-card-title>
        <validation-observer ref="observer">
          <v-card-text>
            <v-expansion-panels v-model="panelPatient" class="mb-10">
              <v-expansion-panel
                v-for="(patientInfo, index) in patientInfoList"
                :key="index"
              >
                <v-expansion-panel-header>
                  <span>
                    <v-icon left color="grey">mdi-account-search </v-icon
                    >Paciente {{ index + 1 }}
                  </span>
                  <template v-slot:actions>
                    <v-icon color="primary"> $expand </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container>
                    <v-row>
                      <v-col>
                        <h3 class="font-weight-black">Información personal</h3>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          :value="patientInfo.curp"
                          label="CURP"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :value="patientInfo.fullName"
                          label="Nombre"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :value="patientInfo.sexText"
                          label="Sexo"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          :value="patientInfo.birthDate"
                          label="Fecha de nacimiento"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :value="patientInfo.birthFederalEntity"
                          label="Entidad federativa de nacimiento"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <h3 class="font-weight-black">
                          Información de contacto
                        </h3>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          rows="1"
                          :value="patientInfo.address"
                          label="Dirección"
                          id="cancellation"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          :value="patientInfo.phone"
                          label="Número telefónico móvil"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :value="patientInfo.homePhone"
                          label="Número telefónico fijo"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="primary" plain @click="modelInfoPatient = false">
                Continuar <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>

    <!-- end Modals -->
  </div>
</template>

<script>
import {
  PatientRequest,
  PatientFileRequest,
  DownloadZipRequest,
  ReportPDFRequest,
  FederalEntityRequest,
  HealthInsuranceRequest,
  SepomexRequest,
  EvaluationRequest,
  EnumRequest,
} from "@/core/request";
import moment, { locale } from "moment";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../components/Sidebar.vue";
import Datatable from "../components/Datatable.vue";
import AutoLogout from "../components/AutoLogout.vue";
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import BranchOfficesList from "../components/BranchOfficesList.vue";
import ExportImportBtn from "../components/ExportImportBtn.vue";
import CameraSuim from "@/components/CameraSuim.vue";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";

import Viewer from "@/app/components/common/PdfViewer/Viewer.vue";

export default {
  name: "Home",
  data: () => ({
    range: "",
    loader: false,
    dialogDelete: false,
    search: "",
    encabezado: {
      icono: "mdi-account-group",
      texto: "Recepción",
    },
    titleUpdate: {
      icono: "mdi-account",
      texto: "Editar paciente",
    },
    listaPacientes: [],
    headersAddendums: [
      {
        text: "Archivo",
        value: "fileName",
        align: "center",
      },
      { text: "Formato", value: "person.curp", align: "center" },
      {
        text: "Fecha y hora de registro",
        value: "registrationDate",
        align: "center",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        align: "center",
      },
    ],
    headers: [
      { text: "#", value: "counter", align: "center" },
      { text: "Id Paciente", value: "idPatient", align: "center" },
      {
        text: "Nombre del paciente",
        value: "person.fullName",
        align: "center",
      },
      { text: "CURP", value: "person.curp", align: "center" },
      {
        text: "Fecha y hora de registro",
        value: "registrationDate",
        align: "center",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        align: "center",
      },
    ],
    objDelete: {},
    action: 1,
    addendums: [],
    sending: false,
    disabledHeader: false,
    dialogViewer: false,
    file: { bytes: "", fileName: "", type: "", registrationDate: "" },
    objectPatient: "",
    branchOffices: [
      {
        titulo: "Pacientes",
        filtros: [
          { opcion: "CHP-1" },
          { opcion: "CHP-2" },
          { opcion: "CHP-3" },
          { opcion: "CHP-4" },
          { opcion: "CHP-5" },
        ],
        selected: true,
      },
      {
        titulo: "Estatus",
        filtros: [{ opcion: "Activo" }, { opcion: "Inactivo" }],
        selected: false,
      },
    ],
    limitDefault: 3,
    limitBy: 3,
    disabledButton: false,
    idBranchOfficeSelected: null,

    // ! DATA UPDATE PATIENTS
    imagePatient: null,
    //Antecedentes
    antecedents: [],
    panel: 0,
    idPerson: "",
    isImss: false,
    isOther: false,
    isIssste: false,
    flag: true,
    loader: false,
    sending: false,
    validAdress: false,
    date2: null,
    menu2: false,
    activePicker: null,
    nameRules: [(v) => !!v || "Campo requerido"],
    headerModalView: {
      icono: "mdi-account-details",
      texto: "Información del paciente",
    },
    formEditar: {
      healthInsurance: {
        idHealthInsurance: {},
      },
      person: {
        contactInformation: {},
        address: {},
        nationality: {},
        birthFederalEntity: "",
        indigenousLanguage: {},
        disability: {},
      },
    },
    genero: [
      { text: "Femenino", value: "M" },
      { text: "Masculino", value: "H" },
      { text: "No binario", value: "X" },
    ],
    estadoCivil: [],
    federalEntities: [],
    birthFederalEntities: [],
    municipalities: [],
    colonies: [],
    nationality: [
      { text: "Mexicana", value: "Mexicana" },
      { text: "Otra", value: "Otro" },
    ],
    status: [
      { text: "Activo", value: 1 },
      { text: "Inactivo", value: 0 },
    ],
    dateFormatted: null,
    invalidDate: false,
    listHealthInsurance: [],
    patientInfoList: [],
    modelInfoPatient: false,
    panelPatient: 0,
    noPostal: false,
    noColony: false,
    otherColony: "",
    first: 0,
    joblist: [],
    /**validaciones */
    genVal: false,
    entityVal: false,
    birthDateVal: false,
    genericCurp: "XXXX999999XXXXXX99",
    OTHER: "Otro",
    votingLicenseKey: "",
    section: "",
    showVotingLicense: false,
    displayQrStudy: false,
    totalCount: 0,
    currentPage: 1,
    itemsPerPage: 10,
    pageCount: 1,
    searchDelay: null,
    languages: [
    { text: "Sí", value: 1 },
    { text: "No", value: 0 },
  ],
  }),
  computed: {
    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${moment(new Date(this.range.start)).format(
        "DD/MM/YYYY"
      )} al ${moment(new Date(this.range.end)).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }

      this.listAllPagination();
      return true;
    },

    // ! PATIENT UPDATE
    // computedDateFormatted() {
    //   return this.formatDate(this.date2);
    // },
  },
  watch: {
    search(newValue, oldValue) {
      this.deleteSearchDelay();
      this.searchDelay = setTimeout(() => {
        this.currentPage = 1;
        this.listAllPagination();
      }, 400);
    },
    // date2(val) {
    //   this.dateFormatted = this.formatDate(this.date2);
    //   let result = moment(this.dateFormatted, "DD/MM/YYYY", true).isValid();
    //   let today = moment(new Date()).format("YYYY-MM-DD");
    //   if (result) {
    //     if (this.date2 < today) {
    //       this.invalidDate = false;
    //       document.getElementById("fechaNac").style = "none";
    //     } else {
    //       this.invalidDate = true;
    //       this.$utilFront.notifications(
    //         "La fecha no puede ser mayor a la fecha actual",
    //         "ERROR"
    //       );
    //       document.getElementById("fechaNac").style.color = "red";
    //     }
    //   } else {
    //     this.invalidDate = true;
    //     this.$utilFront.notifications("Formato de fecha incorrecto", "ERROR");
    //     document.getElementById("fechaNac").style.color = "red";
    //   }
    // },
    "formEditar.healthInsurance.idHealthInsurance": function (val) {
      if (val.text) {
        if (val.text === "IMSS") {
          this.isImss = true;
          this.isOther = false;
          this.isIssste = false;
          this.formEditar.membershipNumber = "";
        } else if (val.text === "NO APLICA") {
          this.isImss = false;
          this.isOther = false;
          this.isIssste = false;
          this.formEditar.imssNumber = "";
          this.formEditar.medicalAggregated = "";
          this.formEditar.membershipNumber = "";
        } else if (val.text === "OTRO") {
          this.isImss = false;
          this.isOther = true;
          this.isIssste = true;
          this.formEditar.imssNumber = "";
          this.formEditar.medicalAggregated = "";
        } else {
          this.isImss = false;
          this.isOther = false;
          this.isIssste = true;
          this.formEditar.imssNumber = "";
          this.formEditar.medicalAggregated = "";
        }
      }
    },
    "formEditar.healthInsurance.name": function (val) {
      if (val) {
        if (val === "IMSS") {
          this.isImss = true;
          this.isOther = false;
          this.isIssste = false;
          this.formEditar.membershipNumber = "";
        } else if (val === "NO APLICA") {
          this.isImss = false;
          this.isOther = false;
          this.isIssste = false;
          this.formEditar.imssNumber = "";
          this.formEditar.medicalAggregated = "";
          this.formEditar.membershipNumber = "";
        } else if (val === "OTRO") {
          this.isImss = false;
          this.isOther = true;
          this.isIssste = true;
          this.formEditar.imssNumber = "";
          this.formEditar.medicalAggregated = "";
        } else {
          this.isImss = false;
          this.isOther = false;
          this.isIssste = true;
          this.formEditar.imssNumber = "";
          this.formEditar.medicalAggregated = "";
        }
      }
    },
    "formEditar.person.curp": function () {
      this.initCurpValidation();
    },
  },
  components: {
    Encabezado,
    Sidebar,
    Datatable,
    Loader,
    AutoLogout,
    BranchOfficesList,
    ExportImportBtn,
    ValidationObserver,
    ValidationProvider,
    CameraSuim,
    Viewer,
    PatientInformation,
  },
  created() {
    this.setVotingLicense();
    this.setReportMyStudy();
    this.validBrowserTab();
    this.listAllPagination();
    this.listJobs();
  },
  methods: {
    async downloadMiEstudioPDF(item) {
      this.sending = true;
      let params = {
        idPatient: item.idPatient,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      await ReportPDFRequest.downloadQR(params);
      // .then((res) => {
      //   console.log(res);
      //   if (res.status == 200 && res.data.type != "application/json") {
      //     this.$utilFront.openPDF(res.data);
      //   } else {
      //     this.$utilFront.displayErrorPdf(res.data);
      //   }
      // })
      // .catch((e) => {
      //   console.log(e);
      // })
      // .finally(() => {
      //   this.sending = false;
      // });
      this.sending = false;
    },
    listJobs() {
      PatientRequest.listJobs().then((res) => {
        let { data } = res;
        this.joblist = data;
      });
    },
    async setVotingLicense() {
      this.showVotingLicense = false;
      let params = {
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      await PatientRequest.getConfigReception(params).then((res) => {
        let { data, code, status } = res.data;
        if (code === 200 && status === "OK") {
          sessionStorage.setItem('idBranchOffice', data.idBranchOffice);
          this.showVotingLicense =
            data.displayVotingLicense != null
              ? data.displayVotingLicense
              : false;
        }
      });
    },
    async setReportMyStudy() {
      this.displayQrStudy = false;
      let params = {
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
      };
      await PatientRequest.getConfigReception(params).then((res) => {
        let { data, code, status } = res.data;
        if (code === 200 && status === "OK") {
          sessionStorage.setItem('idBranchOffice', data.idBranchOffice);
          this.displayQrStudy =
            data.displayQrStudy != null ? data.displayQrStudy : false;
        }
      });
    },
    initCurpValidation() {
      this.gendervalidation();
      this.entityvalidation();
      // this.birthdatevalidation();
    },
    gendervalidation() {
      let validate = true;
      let curpgender = this.formEditar.person.curp;
      if (this.genericCurp == this.formEditar.person.curp) {
        validate = false;
      }
      if (validate) {
        switch (curpgender.charAt(10)) {
          case "H":
            this.formEditar.person.gender = "H";
            this.genVal = true;
            break;
          case "M":
            this.formEditar.person.gender = "M";
            this.genVal = true;
            break;
          case "X":
            this.formEditar.person.gender = "X";
            this.genVal = true;
            break;
        }
      }
    },
    entityvalidation() {
      let validate = true;
      let entityName = "";
      let entityCurp =
        this.formEditar.person.curp.charAt(11) +
        this.formEditar.person.curp.charAt(12);
      if (this.genericCurp == this.formEditar.person.curp) {
        validate = false;
      }
      if (validate) {
        for (let i in this.birthFederalEntities) {
          if (this.birthFederalEntities[i].entitykey == entityCurp) {
            entityName = this.birthFederalEntities[i].text;
          }
        }
        this.formEditar.person.birthFederalEntity = entityName;
        this.entityVal = true;
      }
    },
    clearCalendar() {
      this.range = "";
      this.listAllPagination();
    },
    exportBranchOffice() {
      this.sending = true;

      ReportPDFRequest.exportPatient()
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel",
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Pacientes.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    toggle(limitDefault, branchOfficesLength) {
      this.limitBy =
        this.limitBy === limitDefault ? branchOfficesLength : limitDefault;
    },
    ask(event, item) {
      event.stopPropagation();
      event.preventDefault();
      this.getItem(item);
    },
    catchError(e) {
      // console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno.", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        //this.$refs.observer.reset();
        this.listAllPagination();
        this.action = action;
      } else if (action == 2) {
        this.sending = false;
        this.action = action;
      } else if (action == 3) {
        this.sending = true;
        this.action = action;
      }

      this.disabledHeader = this.action == 2;
    },

    // listPatientsByDate() {
    //   this.loader = true;
    //   let data = {
    //     idBranchOffice:
    //       this.idBranchOfficeSelected != null
    //         ? this.idBranchOfficeSelected
    //         : "",
    //     start: this.range.start
    //       ? moment(this.range.start).startOf("day")
    //       : null,
    //     end: this.range.end ? moment(this.range.end).endOf("day") : null,
    //     statusUserList: [],
    //   };

    //   PatientRequest.listPatientsByDate(data)
    //     .then((res) => {
    //       if (res.data.code === 200 && res.data.status === "OK") {
    //         this.listaPacientes = res.data.data.map((patient) => {
    //           return {
    //             idPatient: patient.idPatient,
    //             fullNamePatient: patient.fullName,
    //             curp: patient.curp || "---",
    //             status: patient.status,
    //             registrationDate: this.$utilFront.formatDateTime(
    //               patient.registrationDate
    //             ),
    //           };
    //         });
    //       } else if (res.data.code === 401) {
    //         this.unauthorized();
    //       } else {
    //         this.$utilFront.notifications(
    //           "Sucedio un error interno del sistema",
    //           "ERROR"
    //         );
    //       }
    //     })
    //     .finally(() => {
    //       this.loader = false;
    //     });
    // },
    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    deleteSearchDelay() {
      if (this.searchDelay != null) {
        clearTimeout(this.searchDelay);
        this.searchDelay = null;
      }
    },
    listAllPagination() {
      this.loader = true;
      let params = {
        search: this.search,
        maxResults: this.itemsPerPage,
        page: this.currentPage,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      if (this.$utilFront.nonEmpty(this.range)) {
        params.start = this.$utilFront.startOfDay(this.range.start);
        params.end = this.$utilFront.endOfDay(this.range.end);
      }

      PatientRequest.listPatientsPagination(params)
        .then((res) => {
          this.loader = false;
          let { list, count } = res.data;
          this.listaPacientes = list;
          this.totalCount = count;
          this.pageCount = Math.ceil(count / this.itemsPerPage);

          if (
            (count > 0 &&
              this.$utilFront.isEmptyList(list) &&
              this.currentPage > 1) ||
            this.currentPage > this.pageCount
          ) {
            this.changePage(1);
          }
        })
        .catch((e) => {
          this.loader = false;
          this.$utilFront.errorhttp(e);
        });
    },
    getItem(item) {
      this.objDelete = item;
      this.dialogDelete = true;
    },
    deletePatient() {
      this.sending = true;
      this.loader = true;
      PatientRequest.deletePatient({
        idPatient: this.objDelete.idPatient,
      })
        .then((res) => {
          if (res.data.data) {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.$utilFront.notifications(
                "Estatus de paciente modificado correctamente",
                "SUCCESS"
              );
              this.listAllPagination();
              this.loader = false;
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Estatus de paciente no ha sido modificado",
                "ERROR"
              );
            }
            this.dialogDelete = false;
          } else {
            this.$utilFront.notifications(
              "Sucedio un error interno del sistema",
              "ERROR"
            );
            this.dialogDelete = false;
          }
        })
        .finally(() => {
          this.sending = false;
          this.loader = false;
        });
    },

    changeViewAddendums(item) {
      try {
        this.sending = true;
        this.loader = true;
        this.model = {};
        let data = { idPatient: item.idPatient };
        this.objectPatient = item;
        this.model = data;

        PatientFileRequest.findAddendumsByPatient(data)
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && typeof data === "object") {
              this.addendums = data.addendumList;
              this.addendums.map((a) => {
                a.registrationDate = this.$utilFront.formatDate(
                  a.registrationDate
                );
              });
              this.changeAction(2);
            } else if (code == 401) {
              this.unauthorized();
            } else if (typeof data == "string") {
              this.$utilFront.notifications(data, "ERROR");
            } else {
              this.catchError();
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
            this.loader = false;
          });
      } catch (e) {
        this.catchError(e);
        this.loader = false;
      }
    },
    visualizar(item) {
      let data = {
        idPatient: this.objectPatient.idPatient,
        fileName: item.fileName,
      };
      try {
        PatientFileRequest.findOneAddendumByPatient(data)
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && typeof data === "object") {
              this.file = data;
              this.file.registrationDate = item.registrationDate;
              this.file.idPatientFile = item.idPatientFile;

              this.dialogViewer = true;
            } else if (code == 401) {
              this.unauthorized();
            } else if (typeof data == "string") {
              this.$utilFront.notifications(data, "ERROR");
            } else {
              this.catchError();
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },

    download(item) {
      this.disabledButton = true;
      try {
        this.loader = true;
        let data = {
          idPatient: this.objectPatient.idPatient,
          fileName: item.fileName,
        };
        DownloadZipRequest.downloadPatientFile(data).then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: item.fileName,
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.fileName);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          this.loader = false;
          this.disabledButton = false;
        });
      } catch (e) {
        this.disabledButton = false;
        this.loader = false;
        this.catchError(e);
      }
    },

    deleteFile(item) {
      this.disabledButton = true;
      this.loader = true;
      try {
        let data = {
          idPatientFile: item.idPatientFile,
          fileName: item.fileName,
          idPatient: this.objectPatient.idPatient,
        };
        PatientFileRequest.deleteFileByPatient(data).then((res) => {
          if (res.data.status == "OK" && res.data.data == true) {
            this.$utilFront.notifications(
              "Archivo eliminado correctamente",
              "SUCCESS"
            );
            this.dialogViewer = false;
            this.addendums = this.addendums.filter((a) => {
              return a.fileName !== item.fileName;
            });
            this.disabledButton = false;
          } else if (res.data.code == 401) {
            this.unauthorized();
          } else if (typeof res.data.data == false) {
            this.$utilFront.notifications(
              "Error al eliminar el archivo",
              "ERROR"
            );
          } else {
            this.catchError();
          }
        });
        this.disabledButton = false;
        this.loader = false;
      } catch (e) {
        this.disabledButton = false;
        this.loader = false;
        this.catchError(e);
      }
    },
    createAppointment(patient) {
      this.sending = true;
      this.loader = true;
      this.$router.push({
        name: "CrearCita",
        params: { idPatient: patient.idPatient },
      });
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllPagination();
      this.setVotingLicense();
    },
    async downloadReport(typeFile) {
      this.sending = true;
      let fileName = typeFile == 1 ? "Pacientes.pdf" : "Pacientes.xlsx";

      ReportPDFRequest.exportPatient({
        typeFile: typeFile,
        fileName: fileName,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : "",
        start: this.range.start
          ? moment(this.range.start).startOf("day")
          : null,
        end: this.range.end ? moment(this.range.end).endOf("day") : null,
        statusUserList: [],
      })
        .then((res) => {
          if (this.$utilFront.isJSON(res.data.type)) {
            this.$utilFront.displayErrorBlog(res.data);
          } else {
            switch (typeFile) {
              case 1: //PDF
                this.$utilFront.openPDF(res.data);
                break;
              case 2: //XLSX
                this.$utilFront.downloadXLSX(res.data, fileName);
                break;
            }
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },

    // ! METHODS UPDATE PATIENTS
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    upperCase(e) {
      if (this.formEditar.person.curp) {
        this.formEditar.person.curp = e.toUpperCase();
      }
    },
    capitalizeName(e) {
      // const strName = e;

      // const arr = strName.split(" ");

      // for (let i = 0; i < arr.length; i++) {
      //   arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
      // }

      // const newStrName = arr.join(" ");

      // this.formEditar.person.name = newStrName;
    },
    capitalizeLastname(e) {
      // const strName = e;

      // const arr = strName.split(" ");

      // for (let i = 0; i < arr.length; i++) {
      //   arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
      // }

      // const newStrName = arr.join(" ");

      // this.formEditar.person.firstLastname = newStrName;
    },
    capitalizeSurname(e) {
      // const strName = e;

      // const arr = strName.split(" ");

      // for (let i = 0; i < arr.length; i++) {
      //   arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
      // }

      // const newStrName = arr.join(" ");

      // this.formEditar.person.secondLastname = newStrName;
    },
    saveNac(date2) {
      this.$refs.menu2.save(date2);
    },
    async getPatient(idPatient) {
      this.setVotingLicense();
      let id = idPatient;

      await PatientRequest.listPatientById({ idPatient: id })
        .then((res) => {
          this.loader = true;
          if (res.data.code === 200 && res.data.status === "OK") {
            this.formEditar = res.data.data;
            this.formEditar.educationName = { name: res.data.data.educationName };
            if (this.formEditar.votingLicense == null) {
              this.votingLicenseKey = "";
              this.section = "";
            } else {
              this.votingLicenseKey =
                this.formEditar.votingLicense.votingLicenseKey;
              this.section = this.formEditar.votingLicense.section;
            }
            this.otherColony = this.formEditar.person.address.colonyKey;
            this.findAddress(true);
            // this.date2 = this.formEditar.person.birthDate;
            this.date2 = moment.utc(this.formEditar.person.birthDate).format(
              "YYYY-MM-DD"
            );
            this.dateFormatted = this.date2;
            this.loader = false;
            this.idPerson = res.data.data.person.idPerson;
            this.getAntecents();
            /*Iniciar address*/

            if (this.formEditar.person.nationality != "Mexicana") {
              this.otherNationality = this.formEditar.person.nationality;
              this.formEditar.person.nationality = "Otro";
            }
            this.changeAction(3);
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        })
        .then(() => {
          this.listAllEntities();
          this.listAllHealthInsurances();
          this.listMaritalStatus();
        });
    },
    /// Antecente -> inicio
    getAntecents() {
      this.sending = true;
      this.antecedents = [];
      EvaluationRequest.listByPersonAndType({
        type: 1,
        idPerson: this.idPerson,
      })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.antecedents = data;
            this.panel = this.antecedents.map((it, i) => {
              return i;
            });
          } else {
            this.antecedents = [];
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    // Antecente -> fin
    async editPatient() {
      this.sending = true;
      let obj = this.formEditar;
      let enti;
      let nan;
      let idee = "";
      if (obj.imssNumber === "") {
        idee = "";
        obj.imssNumber = "";
      } else {
        idee = obj.imssNumber + obj.medicalAggregated;
      }
      if (obj.person.nationality === "Otro") {
        enti = "Ninguno";
        nan = this.otherNationality;
      } else {
        enti = obj.person.birthFederalEntity;
        nan = obj.person.nationality;
      }
      if (this.noPostal || this.noColony) {
        obj.person.address.colonyKey = this.otherColony;
      }
      this.imagePatient = await this.$refs.cameraSUIM.getImage64();

      let updatePatient = {
        idPatient: obj.idPatient,
        idee: idee,
        imssNumber: obj.imssNumber,
        patientNumber: "",
        medicalAggregated: obj.medicalAggregated,
        registrationDate: moment(new Date(obj.registrationDate)).format(),
        rfc: obj.rfc,
        educationName: obj.educationName?.name || "",
        sendInformation: obj.sendInformation,
        membershipNumber: obj.membershipNumber,
        healthInsurance: {
          idHealthInsurance:
            obj.healthInsurance.idHealthInsurance.value ||
            obj.healthInsurance.idHealthInsurance,
          name: obj.nameOther,
          description: obj.description,
        },

        person: {
          idPerson: obj.person.idPerson,
          name: obj.person.name,
          firstLastname: obj.person.firstLastname,
          secondLastname: obj.person.secondLastname,
          curp: obj.person.curp,
          gender: obj.person.gender,
          birthDate: moment.utc(this.date2).format(),
          birthDateText: this.date2,
          birthFederalEntity: enti,
          maritalStatus: obj.person.maritalStatus,
          status: obj.person.status,
          contactInformation: {
            idContactInformation:
              obj.person.contactInformation.idContactInformation,
            email: obj.person.contactInformation.email,
            phone: obj.person.contactInformation.phone,
            homePhone: obj.person.contactInformation.homePhone,
          },
          branchOffice: {
            idBranchOffice: this.$utilFront.getIdBranchOffice(),
          },
          address: {
            idAddress: obj.person.address.idAddress,
            interiorNumber: obj.person.address.interiorNumber,
            outdoorNumber: obj.person.address.outdoorNumber,
            postalCode: obj.person.address.postalCode,
            street: obj.person.address.street,
            federalEntityKey: obj.person.address.federalEntityKey,
            municipalityKey: obj.person.address.municipalityKey,
            colonyKey: obj.person.address.colonyKey,
          },
          nationality: nan,
          indigenousLanguage: obj.person.indigenousLanguage,
          disability: obj.person.disability,
        },
        votingLicense: {
          votingLicenseKey: this.votingLicenseKey,
          section: this.section,
        },
        occupation: obj.occupation,
        evaluations: this.antecedents,
        imagePatient: this.imagePatient,
      };

      PatientRequest.updatePatient(updatePatient)
        .then((res) => {
          let { data, response, message } = res.data;

          if (response) {
            this.$utilFront.notifications(
              "Información actualizada.",
              "SUCCESS"
            );
            this.changeAction(1);
          } else {
            message = message || "Ocurrió un error al guardar.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .finally(() => {
          this.sending = false;
          this.listAllPagination();
        });
    },
    //Catalogos
    listAllEntities() {
      FederalEntityRequest.listAllFederalEntity().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.birthFederalEntities = res.data.data.map((entity) => {
            return {
              text: entity.name,
              value: entity.name,
              entitykey: entity.federalEntityKey,
            };
          });
          this.initCurpValidation();
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listAllHealthInsurances() {
      HealthInsuranceRequest.listAllHealthInsurance().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.listHealthInsurance = res.data.data.map((insurance) => {
            return {
              text: insurance.name,
              value: insurance.idHealthInsurance,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    findAddress(firstLoad) {
      this.sending = true;
      this.noColony = false;
      this.noPostal = false;
      this.validAdress = false;

      this.federalEntities = [];
      this.municipalities = [];
      this.colonies = [];

      let postalCode = this.formEditar.person.address.postalCode;

      SepomexRequest.listAllByPostalCode({ postalCode: `${postalCode}` })
        .then((res) => {
          let { data, response, message } = res.data;

          if (response) {
            this.federalEntities = data
              .map((it) => {
                return it.federalEntity;
              })
              .filter(this.onlyUnique);
            let federalEntityKey =
              this.formEditar?.person?.address?.federalEntityKey || null;
            if (
              this.$utilFront.isNull(federalEntityKey) ||
              this.federalEntities.includes(federalEntityKey) ||
              firstLoad != true
            ) {
              this.formEditar.person.address.federalEntityKey =
                this.federalEntities[0];
            }

            this.municipalities = data
              .map((it) => {
                return it.municipality;
              })
              .filter(this.onlyUnique);
            let municipalityKey =
              this.formEditar?.person?.address?.municipalityKey || null;
            if (
              this.$utilFront.isNull(municipalityKey) ||
              this.municipalities.includes(municipalityKey) ||
              firstLoad != true
            ) {
              this.formEditar.person.address.municipalityKey =
                this.municipalities[0];
            }

            this.colonies = data
              .map((it) => {
                return it.settlement;
              })
              .filter(this.onlyUnique);
            this.colonies.push(Object.assign(this.OTHER));

            let colonyKey = this.formEditar?.person?.address?.colonyKey || null;
            if (
              (this.$utilFront.isNonNull(colonyKey) &&
                !this.colonies.includes(colonyKey)) ||
              firstLoad != true
            ) {
              this.otherColony = colonyKey;
              this.formEditar.person.address.colonyKey = Object.assign(
                this.OTHER
              );
              this.noColony = true;
            } else if (
              this.$utilFront.isNull(colonyKey) ||
              this.colonies.includes(colonyKey)
            ) {
              // this.formEditar.person.address.colonyKey = this.colonies[0];
            }
          } else {
            this.noPostal = true;
            this.noColony = true;
            if (firstLoad != true) {
              this.formEditar.person.address.federalEntityKey = "";
              this.formEditar.person.address.municipalityKey = "";
              this.formEditar.person.address.colonyKey = "";
              this.otherColony = "";
            }

            this.$utilFront.notifications(
              "Código postal no registrado, capturar manualmente.",
              "WARNING"
            );
          }
        })
        .finally(() => (this.sending = false));
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    checkColony() {
      this.noColony =
        this.formEditar.person.address.colonyKey?.toString() ===
        Object.assign(this.OTHER)?.toString();
    },
    validateCurp(e) {
      let data = {
        person: { curp: this.formEditar.person.curp },
      };
      PatientRequest.validCurpPatient(data).then((res) => {
        if (res.data.code === 200 && typeof res.data.data == "object") {
          if (res.data.data != null) {
            this.patientInfoList = res.data.data.filter((d) => {
              if (d.idPatient != this.formEditar.idPatient) {
                d.birthDate =
                  moment(new Date(d.birthDate))
                    .locale("es")
                    .format("DD/MM/YYYY") || "---";
                //d.phone = (res.data.data.phone != null? res.data.data.phone: "ND")
                return d;
              }
            });
            if (this.patientInfoList.length > 0) {
              this.modelInfoPatient = true;
              this.panelPatient = 0;
            }
          }
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
        }
      });
    },
    createAppointment(patient) {
      this.sending = true;
      this.loader = true;
      this.$router.push({
        name: "CrearCita",
        params: { idPatient: patient.idPatient },
      });
    },
    listMaritalStatus() {
      EnumRequest.listAllMaritalStatus().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.estadoCivil = res.data.data.map((status) => {
            return {
              text: status.text,
              value: status.value,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
  },
};
</script>
<style scoped>
.btn-grad {
  background-image: linear-gradient(
    to right,
    #76b852 0%,
    #8dc26f 51%,
    #76b852 100%
  );
}

.btn-grad {
  margin: 10px;
  padding: 15px 45px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  display: block;
}

.btn-grad:hover {
  background-position: right center;
  /* change the direction of the change here */
  color: #fff;
  text-decoration: none;
}

.v-application a {
  color: transparent;
}
</style>